import { render } from "./ChatContent.vue?vue&type=template&id=59cf4fe2"
import script from "./ChatContent.vue?vue&type=script&lang=js"
export * from "./ChatContent.vue?vue&type=script&lang=js"

import "./ChatContent.vue?vue&type=style&index=0&id=59cf4fe2&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__